import React from 'react'

export default function ExtractResources(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="currentColor"
          d="M30.3 8.7v23.2c0 1.8-1.5 3.2-3.2 3.2H5c-1.8 0-3.2-1.5-3.2-3.2v-28C1.8 2.1 3.2.6 5 .6h17.2c.5 0 1.1.2 1.4.6l6.1 6c.3.4.6 1 .6 1.5Z"
          opacity=".1"
        />
        <path fill="currentColor" d="M25.963 8.038h-8.276v8.324h8.276V8.038Z" />
        <path
          fill="currentColor"
          d="M25.926 8.075v8.259h-8.211V8.075h8.21ZM26 8h-8.35v8.4H26V8ZM14.354 19.605H6.037v8.311h8.317v-8.311Z"
        />
        <path
          fill="currentColor"
          d="M14.317 19.642v8.246H6.065v-8.246h8.252Zm.075-.075H6v8.386h8.392v-8.386Zm10.31 1.255v5.855h-5.753v-5.854H24.7ZM26 19.5h-8.35V28H26v-8.5ZM13.062 9.312v5.808H7.309V9.312h5.753ZM14.36 8H6.01v8.43h8.35V8Z"
        />
        <path
          fill="currentColor"
          d="M14.317 19.642v8.246H6.065v-8.246h8.252Zm.075-.075H6v8.386h8.392v-8.386Zm10.31 1.255v5.855h-5.753v-5.854H24.7ZM26 19.5h-8.35V28H26v-8.5ZM13.062 9.312v5.808H7.309V9.312h5.753ZM14.36 8H6.01v8.43h8.35V8Z"
        />
        <path
          fill="currentColor"
          d="M30.2 6.8 23.8.6c-.3-.4-.9-.6-1.4-.6h-18C2.6 0 1 1.5 1 3.4v29.2C1 34.5 2.6 36 4.4 36h23.1c1.9 0 3.4-1.5 3.4-3.3V8.5c.1-.7-.2-1.3-.7-1.7Zm-.4 24.9c0 1.7-1.4 3.2-3.1 3.2H5.3c-1.7 0-3.1-1.4-3.1-3.2V4.3c0-1.7 1.4-3.2 3.1-3.2h16.5c.5 0 1 .2 1.4.6l5.9 5.8c.4.4.7 1 .6 1.6v22.6h.1Z"
        />
      </svg>
    </div>
  )
}
